export default "__VITE_ASSET__D8rggdZN__"